// English translations — RajDarshan Tandon Dairy
// Loaded lazily only when user selects English (default)

const en = {
    // Header
    home: "Home",
    about: "About",
    purity: "Purity",
    contact: "Contact",

    // Language Popup
    languageTitle: "Choose Your Language",
    languageSubtitle: "Select your preferred language to continue",
    hindi: "हिंदी",
    english: "English",
    continue: "Continue",

    // Hero Section
    heroTitle: "Pure Milk, Straight from Our Family to Yours",
    heroSubtitle: "Three generations of trust. Zero chemicals. Just pure, high-protein milk delivered in traditional steel cans across Raipur.",
    heroHighlight: "Serving 500+ Families Since 1969",
    ctaCall: "Call for Subscription",
    ctaWhatsapp: "Message on WhatsApp",

    // About Section
    aboutTitle: "Our Heritage",
    aboutSubtitle: "A Legacy of Purity Spanning Three Generations",
    aboutDesc: "For over 50 years, RajDarshan Tandon Dairy has been Raipur's trusted source of pure, unadulterated milk. We believe in the old ways – no packaging, no preservatives, no shortcuts. Just honest milk from cows we treat as family.",
    aboutStat1: "500+",
    aboutStat1Label: "Happy Families",
    aboutStat2: "50+",
    aboutStat2Label: "Years of Trust",
    aboutStat3: "100%",
    aboutStat3Label: "Chemical-Free",

    // Features Section
    featuresTitle: "Why RajDarshan Dairy?",
    featuresSubtitle: "The Difference Is in Our Tradition",
    feature1Title: "No Hard Processing",
    feature1Desc: "Our milk is never heated, pasteurized, homogenized, or subjected to any hard processing. It's just pure, raw, farm-fresh milk delivered exactly as nature intended.",
    feature2Title: "Zero Additives",
    feature2Desc: "No preservatives, no chemicals, no water mixing. What comes from our cows reaches your doorstep in its purest form.",
    feature3Title: "High-Protein Natural Milk",
    feature3Desc: "Our cows graze on natural pastures and are never given hormones. The result? Rich, creamy milk with exceptional nutritional value.",
    feature4Title: "Traditional Desi Methods",
    feature4Desc: "From hand-milking to steel can delivery, we honor age-old practices that ensure quality and preserve the milk's natural goodness.",

    // Cow Care Section
    cowCareTitle: "Our Cows Are Family",
    cowCareSubtitle: "Not Machines, But Cherished Members of Our Home",
    cowCareDesc: "At RajDarshan Farms, we worship and care for our cows with devotion. They roam free in lush pastures, receive the best nutrition, and are treated with love and respect. This isn't just business – it's a sacred responsibility passed down through generations. Happy cows give the best milk.",
    cowCarePoint1: "Free-range grazing in natural pastures",
    cowCarePoint2: "Regular veterinary care and attention",
    cowCarePoint3: "No growth hormones or artificial feeds",
    cowCarePoint4: "Worshipped and treated with reverence",

    // Testimonials
    testimonialsTitle: "What Our Families Say",
    testimonial1: "The taste reminds me of my childhood in the village. You can tell the difference in quality!",
    testimonial1Author: "Priya Sharma",
    testimonial1Location: "Civil Lines, Raipur",
    testimonial2: "Best decision we made for our children's health. Pure milk, no compromise.",
    testimonial2Author: "Amit Verma",
    testimonial2Location: "Shankar Nagar, Raipur",
    testimonial3: "Serving our family for 15 years. The trust and quality never wavered.",
    testimonial3Author: "Rekha Joshi",
    testimonial3Location: "Devendra Nagar, Raipur",

    // CTA Section
    ctaTitle: "Experience the Purity of Tradition",
    ctaSubtitle: "Join 500+ families across Raipur who trust RajDarshan for their daily milk needs",
    ctaButton: "Subscribe Now",

    // Footer
    footerTagline: "Serving Purity Since 1969",
    footerAddress: "Raipur, Chhattisgarh",
    footerContact: "Contact Us",
    footerPhone: "9039610400",
    footerRights: "© 2026 RajDarshan Tandon Dairy. All rights reserved.",
    footerDelivery: "Delivering across Raipur with love and care",
    footerSubscription: "Our Subscription Model",
    footerQuality: "Our Milk & Quality",
    footerAreas: "Delivery Areas in Raipur",

    // Quality Page
    qualPageTitle: "A2 Cow & Buffalo Milk Raipur – Pure, No Adulteration",
    qualPageMeta: "RajDarshan provides pure A2 cow milk and buffalo milk in Raipur. No water mixing, no chemicals, no adulteration. Know the truth about packaged milk in India and why local dairy is your safest choice.",
    qualHeroBadge: "A2 Cow Milk · Buffalo Milk · Raipur",
    qualHeroTitle: "What You Think Is Milk Might Not Be.",
    qualHeroSubtitle: "India's packaged milk industry has a dark side. Detergents. Urea. Synthetic fats. Your family deserves to know — and deserves better.",
    qualHeroCallBtn: "Get Pure Milk – Call Us",
    qualHeroWhatsappBtn: "WhatsApp for Details",
    qualTruth: "The Truth About Indian Milk",
    qualTruthSubtitle: "Verified by India's own food authority — FSSAI",
    qualStat1: "41%",
    qualStat1Label: "of packaged milk samples failed quality standards",
    qualStat1Src: "FSSAI National Survey 2018 (6,432 samples)",
    qualStat2: "38%",
    qualStat2Label: "of milk in 2022 found adulterated",
    qualStat2Src: "FSSAI Milk Surveillance Report 2022",
    qualStat3: "12,000+",
    qualStat3Label: "legal cases filed for milk adulteration in 2024-25",
    qualStat3Src: "India Today / FSSAI Enforcement Drive 2024",
    qualStat4: "500L",
    qualStat4Label: "of fake milk made from 1 litre of chemicals",
    qualStat4Src: "India Times – Uttar Pradesh Arrest, 2024",
    qualCasesTitle: "Real Cases. Real Risk.",
    qualCasesSubtitle: "These are not rumours. These are verified, reported facts.",
    qualMilkTitle: "Our Milk, Explained Simply",
    qualMilkSubtitle: "Two milks. One promise: pure, natural, and chemical-free.",
    qualCow: "Cow Milk",
    qualCowDesc: "We raise two distinct families of cows at our farm. Our native desi cows — Gir, Sahiwal and Tharparkar breeds — give rich, naturally flavourful milk known for its purity and easy digestion. Alongside them, we also care for cows that naturally produce A2 beta-casein milk, a gentler protein variant ideal for children, the elderly, and those with sensitive digestion. Whether you're looking for the deep richness of desi milk or the gut-friendly benefits of A2 milk, both come from cows that are pasture-grazed, naturally fed, and treated as part of our family.",
    qualCowTags: ["Desi Breeds", "A2 Available", "Pasture-Grazed", "Best for Kids"],
    qualBuffalo: "Buffalo Milk",
    qualBuffaloDesc: "Rich, creamy, and naturally high in fat — our buffalo milk is perfect for making ghee, paneer, khoya, and curd. Naturally higher protein and calcium content than cow milk, making it a powerhouse for traditional Indian cooking and daily nutrition.",
    qualBuffaloTags: ["High Fat & Protein", "Best for Ghee & Paneer", "Rich in Calcium", "Great for Cooking"],
    qualCareTitle: "Why Our Milk Tastes Different",
    qualCareSubtitle: "It has nothing to do with magic. Everything to do with care.",
    qualCare1: "Cows as Family, Not Machines",
    qualCare1Desc: "In Indian tradition, the cow is sacred — Gau Mata. We live by this. Our cows have names. They roam open pastures. They are never stressed or over-milked. Happy cows produce richer, more nutritious milk.",
    qualCare2: "Premium Feed, Open Grazing",
    qualCare2Desc: "Our cattle graze freely on natural grass and receive the best available natural feed — no artificial additives, hormones, or growth agents. What they eat, your family drinks.",
    qualCare3: "No Hormones. No Antibiotics.",
    qualCare3Desc: "We never inject growth hormones or routine antibiotics into our cattle. No shortcuts. No chemicals entering the milk chain — and therefore no chemicals entering your children.",
    qualCare4: "Farm to Home in 2 Hours",
    qualCare4Desc: "Milk collected at the farm arrives at your door in under 2 hours. No refrigeration. No preservatives. This is what fresh actually means.",
    qualWhyTitle: "Why Local Dairy Is Your Safest Option",
    qualWhyDesc: "Large packaged milk brands collect milk from thousands of farms across hundreds of kilometres. By the time it reaches you, it has been transported, chilled, processed, pasteurised, and homogenised. Your local dairy has none of this distance, none of this risk.",
    qualWhyPoint1: "Zero distance from farm to your door",
    qualWhyPoint2: "No processing or pasteurisation strips nutrients",
    qualWhyPoint3: "You know exactly where your milk comes from",
    qualWhyPoint4: "55+ years of accountability to the same community",
    qualWhyPoint5: "One family's name behind every litre we deliver",
    qualCTATitle: "Your Family Deserves Real Milk.",
    qualCTASubtitle: "Pure A2 cow milk and buffalo milk, delivered from our farm to your door every morning in Raipur.",
    qualCTACall: "Call for Pure Milk",
    qualCTAWhatsapp: "WhatsApp Us Now",

    // Subscription Page
    subPageTitle: "Daily Milk Subscription Raipur",
    subPageMetaDesc: "Subscribe to RajDarshan's daily milk delivery in Raipur. Pure desi milk delivered farm-to-home in under 2 hours. Manage your subscription via QR — no app needed.",
    subHeroTitle: "Pure Milk. Delivered Daily. Managed Smartly.",
    subHeroSubtitle: "Raipur's most trusted daily milk subscription — farm-fresh desi milk at your door every morning & evening. Traditional dairy, modern convenience.",
    subHeroBadge: "Daily Milk Subscription · Raipur",
    subHeroCallBtn: "Subscribe Now — Call Us",
    subHeroWhatsappBtn: "Start on WhatsApp",
    subTrustFamilies: "500+ Families",
    subTrustFamiliesLabel: "Trusting Us Daily",
    subTrustYears: "55+ Years",
    subTrustYearsLabel: "Of Pure Milk",
    subTrustChemicals: "0 Chemicals",
    subTrustChemicalsLabel: "Ever. Guaranteed.",
    subTrustFresh: "< 2 Hours",
    subTrustFreshLabel: "Farm to Your Door",
    subHowTitle: "How Your Subscription Works",
    subHowSubtitle: "Simple. Smart. Stress-Free.",
    subStep1Title: "Call or WhatsApp Us",
    subStep1Desc: "Tell us how much milk you need — morning, evening, or both. We'll set up your daily home delivery milk subscription instantly.",
    subStep2Title: "We Set Up Your Account",
    subStep2Desc: "Your personal milk khaata (ledger) is created. You get a unique subscription link — no app to install, just a browser link.",
    subStep3Title: "Receive Your Personal QR Code",
    subStep3Desc: "We provide you a printed QR card — or you can save it on your phone. When the hawker arrives, simply show it to receive your milk. Not home? Just don't show it — delivery is skipped and your balance stays intact.",
    subStep4Title: "Fresh Delivery Every Morning & Evening",
    subStep4Desc: "Pure desi milk collected from the farm, filled in traditional steel cans, and delivered to your door — all within 2 hours.",
    subStep5Title: "Track Your Balance Anytime",
    subStep5Desc: "Check how much milk is remaining in your subscription via your personal link. No app. No login. Just click and see.",
    subQRTitle: "Your Personal QR — Total Freedom Over Your Delivery",
    subQRSubtitle: "Printed card or saved on your phone. Show it when you want milk. Don't show it when you don't.",
    subQRPoint1: "We give you a QR code — printed card or saved on your mobile.",
    subQRPoint2: "Hawker arrives → you show QR → milk is delivered. Simple.",
    subQRPoint3: "Don't want milk? Just don't show the QR — delivery is skipped, zero deduction.",
    subQRPoint4: "No need to call. No need to pause. Full control, zero hassle.",
    subQRHighlight: "Your QR = your control. Show it or don't — you decide every single delivery.",
    subFreshTitle: "Farm to Your Home in Under 2 Hours",
    subFreshSubtitle: "This is what makes RajDarshan different from every packaged brand.",
    subFreshStep1: "Milked at the Farm",
    subFreshStep2: "Filled in Steel Cans",
    subFreshStep3: "Out for Delivery",
    subFreshStep4: "At Your Door",
    subFreshNote: "No refrigeration needed. No preservatives. Just milk so fresh you can smell the farm.",
    subBenefitsTitle: "Everything You Get With Your Subscription",
    subBenefitsSubtitle: "Traditional dairy values. Modern-day convenience.",
    subBenefit1Title: "No App to Install",
    subBenefit1Desc: "Manage everything via a simple browser link. Works on any phone, even basic ones.",
    subBenefit2Title: "Morning & Evening Delivery",
    subBenefit2Desc: "Double-fresh milk twice a day. Lock in the schedule that works for your family.",
    subBenefit3Title: "Live Balance Tracking",
    subBenefit3Desc: "Always know how many litres are left in your monthly milk delivery Raipur subscription.",
    subBenefit4Title: "Total Delivery Freedom",
    subBenefit4Desc: "Show your QR = get milk. Don't show it = skip delivery. No calls, no apps, no penalties.",
    subBenefit5Title: "Khaata-Style Ledger",
    subBenefit5Desc: "The trusted Indian prepaid system. Recharge, relax — your daily milk subscription Raipur runs itself.",
    subBenefit6Title: "Zero Chemicals, Zero Compromise",
    subBenefit6Desc: "100% pure desi milk. No pasteurisation, no preservatives, no water. Just nature.",
    subFAQTitle: "Common Questions",
    subFAQ1Q: "How do I subscribe?",
    subFAQ1A: "Simply call or WhatsApp us at 9039610400. We'll note your quantity, timing preference (morning/evening), and address — and start delivery the next day.",
    subFAQ2Q: "What if I don't want milk on a particular day?",
    subFAQ2A: "Simply don't show your QR code when the hawker arrives — or if you're not home, just don't leave it out. The hawker will skip your delivery and not a single litre is deducted from your balance.",
    subFAQ3Q: "How do I check my subscription balance?",
    subFAQ3A: "We'll send you a personal link via WhatsApp. Open it anytime in any browser — no app, no login. It shows your remaining litres in real time.",
    subFAQ4Q: "Can I get delivery twice a day?",
    subFAQ4A: "Yes! Many of our customers get both morning and evening deliveries. Just let us know your preference when subscribing.",
    subFAQ5Q: "Is this monthly milk delivery or can I do weekly?",
    subFAQ5A: "We operate on a flexible khaata system. You can recharge for a month, two weeks, or whatever suits you. There's no fixed lock-in period.",
    subCTATitle: "Ready for Pure Milk at Your Doorstep?",
    subCTASubtitle: "Join 500+ Raipur families who've switched to RajDarshan's daily home delivery milk subscription.",
    subCTACall: "Call to Subscribe",
    subCTAWhatsapp: "WhatsApp Us Now",
};

export default en;
